import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupportErrorContext } from '../../_models/support-error-context';

interface DialogData {
  title: string;
  errorMessage: string;
  isValidationError: boolean;
  isAuthFailedInfoError: boolean;
  support?: SupportErrorContext;
}

@Component({
    selector: 'error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.css'],
    standalone: false
})
export class ErrorModalComponent implements OnInit {

  public copied = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
  }

  /** Copy the support diagnostics to the clipboard as a plain-text block for a ticket. */
  public copyDetails(): void {
    const support = this.data.support;
    if (!support || !navigator.clipboard) {
      return;
    }

    const text = [
      `Time: ${support.timestamp}`,
      `Request: ${support.method} ${support.url}`,
      `Status: ${support.status} ${support.statusText}`.trim(),
      `User: ${support.user}`,
      `Request ID: ${support.requestId ?? 'n/a'}`,
      `Correlation ID: ${support.correlationId ?? 'n/a'}`,
      `Error: ${support.errorMessage}`
    ].join('\n');

    navigator.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    });
  }

}
